import React from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SUpdateUser } from '../../../apis/app.service';

import AppButton from '../../sharedcomponents/Buttons/AppButton/AppButton';

import { useUsersPage } from '../../../store/UsersProvider';
import { Spin } from 'antd';

export default function ConfirmInstitutionActive() {
  const { institutionHead } = useUsersPage();
  const { data } = institutionHead;

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: SUpdateUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['users'],
      });
      const { message } = data;
      toast.success(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
    onError(error: Error) {
      const { message } = error;
      toast.error(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
  });

  const handleUpdate = (userId: string, body: any) => {
    mutation.mutate({ userId, body });
  };

  return (
    <>
      <div
        className="modal fade"
        id="kt_modal_confirm_active"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Confirm Action</h2>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              Are you sure you want to turn notifications for
              <strong>{` ${data.organisationName}`}</strong>
              {data.active ? ' Off.' : ' On.'}
            </div>
            <div className="modal-footer">
              <AppButton
                btnType="success"
                onClick={() => handleUpdate(data.id!, { active: !data.active })}
                data-bs-dismiss="modal"
                disabled={mutation.isPending}
              >
                {mutation.isPending && <Spin />}
                Save
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
